var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
export var Input = React.forwardRef(function (props, ref) {
    var customValidity = props.customValidity, required = props.required, pattern = props.pattern, disableDefaultPattern = props.disableDefaultPattern, inputProps = __rest(props, ["customValidity", "required", "pattern", "disableDefaultPattern"]);
    var inputRef = React.useRef(null);
    var refChanged = function (input) {
        inputRef.current = input;
        if (typeof ref === 'function') {
            ref(input);
        }
        else if (ref !== null) {
            ref.current = input;
        }
    };
    React.useLayoutEffect(function () {
        var input = inputRef.current;
        if (input === null) {
            return undefined;
        }
        var validity = customValidity !== null && customValidity !== void 0 ? customValidity : '';
        input.setCustomValidity(validity);
        if (validity !== '') {
            input.reportValidity();
        }
        return undefined;
    }, [customValidity]);
    return (<input pattern={required === true && pattern === undefined && disableDefaultPattern !== true ? '.*[^\\s].*' : pattern} ref={refChanged} required={required} {...inputProps}/>);
});
